import * as web3 from '@solana/web3.js'
import { rpcUrl } from '../config'

export const web3Connection = new web3.Connection(rpcUrl, 'confirmed')
